<div *ngIf="!loadCompleted" class="report-view-page records-page datatable-page-shell report-view-loading">
    <div class="loading">
        {{ 'DATA_IS_LOADING' | translate }}
        <div class="la-ball-spin-clockwise">
          <div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        </div>
    </div>
</div>

<div *ngIf="loadCompleted && validPlatform" class="report-view-page records-page datatable-page-shell">
    <div class="records-page__hero report-view-hero">
        <div class="records-page__hero-primary">
            <div class="records-page__hero-headline">
                <span class="records-page__hero-eyebrow">{{ (iIsRollupReport ? 'ROLLUP_REPORT' : 'CAMPAIGN_REPORT') | translate }}</span>
                <h3 class="records-page__hero-title">{{ campaignName }}<span style="font-size: 1.2rem;" *ngIf="iIsRollupReport && platform"> ({{ toTitleCase(platform) }})</span></h3>
            </div>
        </div>
        <button
            *ngIf="!iIsRollupReport && (isInternalUser && campaignName)"
            type="button"
            class="blue-button report-view-analysis-button"
            (click)="openCampaignAnalysisModal()">
            {{ 'AI_ANALYSIS' | translate }}
        </button>
    </div>
    <div *ngIf="iShowControls" class="report-view-panel report-view-panel--controls datatable-page-surface">
        <div class="report-view-form-shell">
            <form [formGroup]="reportForm" (ngSubmit)="updateReport()" class="report-view-form">
                <div class="report-view-form-row">
                    <div class="report-view-form-item report-view-form-item--period">
                        <label class="report-view-form-label">{{ 'SELECT_REPORT_PERIOD' | translate }}</label>
                        <ng-select
                            [clearable]="false"
                            [attr.aria-label]="'SELECT_PERIOD' | translate"
                            [placeholder]="'SELECT_PERIOD' | translate"
                            [items]="reportPeriods"
                            bindLabel="title"
                            bindValue="key"
                            formControlName="key"
                            (change)="onReportPeriodChange($event)">
                        </ng-select>
                    </div>

                    <div class="report-view-form-item report-view-form-item--date">
                        <label class="report-view-form-label" for="reportViewStartDate">{{ 'START' | translate }}</label>
                        <input id="reportViewStartDate" type="date" [readonly]="datesReadonly" formControlName="startDate"
                        class="form-control form-date date-custom" [ngClass]="{ 'is-invalid': reportForm.controls.startDate.errors }" />
                        <div *ngIf="reportForm.controls.startDate.errors" class="invalid-feedback">
                            <div *ngIf="reportForm.controls.startDate.errors.required">{{ 'SELECT_PERIOD' | translate }}</div>
                        </div>
                    </div>

                    <div class="report-view-form-item report-view-form-item--date">
                        <label class="report-view-form-label" for="reportViewStopDate">{{ 'END' | translate }}</label>
                        <input id="reportViewStopDate" type="date" [readonly]="datesReadonly" formControlName="stopDate"
                        class="form-control form-date date-custom" [ngClass]="{ 'is-invalid': reportForm.controls.stopDate.errors }" />
                        <div *ngIf="reportForm.controls.stopDate.errors" class="invalid-feedback">
                            <div *ngIf="reportForm.controls.stopDate.errors.required">{{ 'SELECT_PERIOD' | translate }}</div>
                        </div>
                    </div>

                    <div class="report-view-form-item report-view-form-item--button">
                        <button type="submit" class="blue-button">{{ 'RUN_REPORT' | translate }}</button>
                    </div>

                    <div class="report-view-form-item report-view-form-item--sections" *ngIf="reportMetrics.Platform === 'Google' || reportMetrics.Platform === 'Meta'">
                        <label class="report-view-form-label">{{ 'SHOW_SECTIONS' | translate }}</label>
                        <div class="report-view-section-options">
                            <div class="form-check report-view-option">
                                <input class="form-check-input" type="checkbox" formControlName="showLeadsByDay" id="showLeadsByDay">
                                <label class="form-check-label" for="showLeadsByDay">{{ isLeadOnlyReport ? ('LEADS_BY_DAY' | translate) : ('CONVERSIONS_BY_DAY' | translate) }}</label>
                            </div>
                            <div *ngIf="reportMetrics.Platform === 'Google'" class="form-check report-view-option">
                                <input class="form-check-input" type="checkbox" formControlName="showKeywords" id="showKeywords">
                                <label class="form-check-label" for="showKeywords">{{ 'KEYWORDS' | translate }}</label>
                            </div>
                            <div *ngIf="reportMetrics.Platform === 'Meta'" class="form-check report-view-option">
                                <input class="form-check-input" type="checkbox" formControlName="showAds" id="showAds">
                                <label class="form-check-label" for="showAds">{{ 'ADS' | translate }}</label>
                            </div>
                            <div *ngIf="reportMetrics.Platform === 'Meta'" class="form-check report-view-option">
                                <input class="form-check-input" type="checkbox" formControlName="showDemographics" id="showDemographics">
                                <label class="form-check-label" for="showDemographics">{{ 'DEMOGRAPHICS' | translate }}</label>
                            </div>
                            <div class="form-check report-view-option">
                                <input class="form-check-input" type="checkbox" formControlName="showDevices" id="showDevices">
                                <label class="form-check-label" for="showDevices">{{ 'DEVICES' | translate }}</label>
                            </div>
                            <div *ngIf="canShowSalesFunnel" class="form-check report-view-option">
                                <input class="form-check-input" type="checkbox" formControlName="showCaculator" id="showCaculator">
                                <label class="form-check-label" for="showCaculator">{{ 'SALES_FUNNEL' | translate }}</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="hasMultipleConversionActions" class="report-view-panel datatable-page-surface" style="margin-top:8px; padding:10px;">
                    <label class="report-view-form-label">{{ 'CONVERSION_ACTIONS_INCLUDED' | translate }}</label>
                    <div fxLayout="row" fxLayoutGap="10px" style="flex-wrap:wrap;">
                        <div *ngFor="let act of conversionActionBreakdown" class="form-check" style="margin-right:12px;">
                            <input class="form-check-input" type="checkbox" [id]="'conv-'+act.key" [checked]="selectedConversionActions.indexOf(act.key) !== -1" (change)="toggleSelectedConversion(act.key)">
                            <label class="form-check-label" [for]="'conv-'+act.key">{{ act.labelKey | translate }} <small *ngIf="act.value">({{ act.value | number }})</small></label>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    </div>

    <div *ngIf="!hasRunReport" class="report-view-panel report-view-panel--content datatable-page-surface report-view-content report-view-prompt">
        <h3 style="text-align: center;">{{ 'SELECT_DATE_RANGE_AND_RUN_REPORT' | translate }}</h3>
    </div>

    <div *ngIf="hasRunReport" class="report-view-panel report-view-panel--content datatable-page-surface report-view-content" [ngClass]="{
        'google': reportMetrics.Platform === 'Google',
        'meta': reportMetrics.Platform === 'Meta'
    }">
        <div class="nodata" *ngIf="reportMetrics.noData; else showSummary">
            <h3 style="text-align: center;">{{ reportMetrics.noData | translate }}</h3>
        </div>
        <ng-template #showSummary>
            <div class="summary summaryCards" [ngClass]="{
                'summaryCards--google': reportMetrics.Platform === 'Google',
                'summaryCards--meta': reportMetrics.Platform === 'Meta'
            }">
                <h3 style="text-align: center;">{{ 'MARKETING_SUMMARY' | translate }}</h3>
                <div class="blocks" style="margin-top: 25px;">
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'COST' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.Cost | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (previousReportMetrics.Cost || 0) | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.Cost, previousReportMetrics.Cost || 0) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'IMPRESSIONS' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.Impressions | number }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (previousReportMetrics.Impressions || 0) | number }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.Impressions, previousReportMetrics.Impressions || 0) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div *ngIf="reportMetrics.Platform === 'Meta'" class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'COST_PER_1000_IMPRESSIONS' | translate }} ({{ 'CPM' | translate }})</div>
                            <div class="metricCardValue">{{ reportMetrics.Cpm | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (previousReportMetrics.Cpm || 0) | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.Cpm, previousReportMetrics.Cpm || 0, true) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'CLICKS' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.Clicks | number }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (previousReportMetrics.Clicks || 0) | number }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.Clicks, previousReportMetrics.Clicks || 0) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div *ngIf="reportMetrics.Platform === 'Google'" class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'COST_PER_CLICK' | translate }} ({{ 'CPC' | translate }})</div>
                            <div class="metricCardValue">{{ reportMetrics.Cpc | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (previousReportMetrics.Cpc || 0) | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.Cpc, previousReportMetrics.Cpc || 0, true) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="blocks" style="margin-top: 25px;">
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'CLICK_THROUGH_RATE' | translate }} ({{ 'CTR' | translate }})</div>
                            <div class="metricCardValue">{{ reportMetrics.Ctr | percent:'1.2-2' }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (previousReportMetrics.Ctr || 0) | percent:'1.2-2' }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.Ctr, previousReportMetrics.Ctr || 0) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ conversionActionCountLabel }}</div>
                            <div class="metricCardValue">{{ (hasConversionActionBreakdown ? (reportMetrics.SelectedConversionActionsTotal || 0) : (reportMetrics.Leads || 0)) | number }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (hasConversionActionBreakdown ? (previousReportMetrics.SelectedConversionActionsTotal || 0) : (previousReportMetrics.Leads || 0)) | number }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.SelectedConversionActionsTotal || reportMetrics.Leads || 0, previousReportMetrics.SelectedConversionActionsTotal || previousReportMetrics.Leads || 0) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ conversionActionRateLabel }}</div>
                            <div class="metricCardValue">{{ reportMetrics.Lsr | percent:'1.2-2' }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (previousReportMetrics.Lsr || 0) | percent:'1.2-2' }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.Lsr, previousReportMetrics.Lsr || 0) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ conversionActionCostLabel }}</div>
                            <div class="metricCardValue">{{ reportMetrics.Cpl | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</div>
                            <div *ngIf="!iIsRollupReport" class="metricCardPrev"><small>{{ 'PREVIOUS' | translate }}: {{ (previousReportMetrics.Cpl || 0) | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</small></div>
                        </div>
                        <ng-container *ngIf="!iIsRollupReport && getDeltaInfo(reportMetrics.Cpl, previousReportMetrics.Cpl || 0, true) as d">
                            <div class="metricCardDelta" [ngClass]="d.className">
                                <div class="metricCardDeltaArrow" aria-hidden="true">{{ d.direction === 'up' ? '▲' : d.direction === 'down' ? '▼' : '—' }}</div>
                                <div class="metricCardDeltaPct">{{ d.pct === null ? '—' : (d.pct | percent:'1.0-0') }}</div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <div *ngIf="instance.isAltLayout" class="summary summaryCards" [ngClass]="{
                'summaryCards--google': reportMetrics.Platform === 'Google',
                'summaryCards--meta': reportMetrics.Platform === 'Meta'
            }" style="margin-top: 20px;">
                <h3 style="text-align: center;">{{ 'REACH_SUMMARY' | translate }}</h3>
                <div class="blocks" style="margin-top: 25px;">
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'LEADS_STORED_IN_REACH' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.ReachLeads | number }}</div>
                        </div>
                    </div>
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'MEMBERS_MARKED_IN_REACH' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.Members | number }}</div>
                        </div>
                    </div>
                    <div class="kpi">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'COST_PER_MEMBER' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.CpMember | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
        <section *ngIf="reportForm.get('showLeadsByDay')?.value && reportMetrics.Leads > 0" class="leadsChart">
            <h3 style="text-align: center;">{{ isLeadOnlyReport ? ('LEADS_BY_DAY' | translate) : ('CONVERSIONS_BY_DAY' | translate) }}</h3>
            <p style="text-align: center; font-size: 0.9em;">{{ isLeadOnlyReport ? ('LEADS_BY_DAY_NOTE' | translate) : ('CONVERSIONS_BY_DAY_NOTE' | translate) }}</p>
            <div class="background">
                <div class="lineGraph">
                    <canvas
                        aria-label="Leads or conversions by day"
                        baseChart
                        [datasets]="dailyLeadsChartDatasets"
                        [labels]="dailyLeadsChartLabels"
                        [options]="dailyLeadsChartOptions"
                        [colors]="dailyLeadsChartColors"
                        [legend]="false"
                        [chartType]="dailyLeadsChartType">
                    </canvas>
                </div>
            </div>
        </section>

        <section *ngIf="showSalesFunnel">
            <div class="summary summaryCards salesFunnelCards">
                <h3>{{ 'SALES_FUNNEL' | translate }}<sup>*</sup></h3>
                <p class="sales-funnel-note">
                    <em>{{ 'SALES_FUNNEL_CRM_NOTE' | translate:{ platform: reportMetrics.Platform } }}</em>
                </p>
                <div [formGroup]="reportForm" class="caculator">
                    <div class="report-view-calculator-grid">
                        <div class="inputValues">
                            <label for="FunnelLeads">{{ 'LEADS' | translate }}</label>
                            <input id="FunnelLeads" type="number" formControlName="FunnelLeads"
                                class="form-control form-input" />
                        </div>
                        <div class="inputValues">
                            <label for="Booked">{{ 'BOOKED' | translate }}</label>
                            <input id="Booked" type="number" formControlName="Booked" class="form-control form-input" />
                            <div class="sales-funnel-action-options">
                                <div *ngFor="let action of getSalesFunnelActions('Booked')" class="form-check">
                                    <input class="form-check-input" type="checkbox" [id]="'sales-funnel-' + action.key"
                                        [checked]="isSalesFunnelActionSelected(action.key)"
                                        (change)="toggleSalesFunnelAction(action.key)">
                                    <label class="form-check-label" [for]="'sales-funnel-' + action.key">
                                        {{ action.labelKey | translate }} <small>({{ action.value | number }})</small>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="inputValues">
                            <label for="Show">{{ 'SHOW' | translate }}</label>
                            <input id="Show" type="number" formControlName="Show" class="form-control form-input" />
                            <div class="sales-funnel-action-options">
                                <div *ngFor="let action of getSalesFunnelActions('Show')" class="form-check">
                                    <input class="form-check-input" type="checkbox" [id]="'sales-funnel-' + action.key"
                                        [checked]="isSalesFunnelActionSelected(action.key)"
                                        (change)="toggleSalesFunnelAction(action.key)">
                                    <label class="form-check-label" [for]="'sales-funnel-' + action.key">
                                        {{ action.labelKey | translate }} <small>({{ action.value | number }})</small>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="inputValues">
                            <label for="Sold">{{ 'SOLD' | translate }}</label>
                            <input id="Sold" type="number" formControlName="Sold" class="form-control form-input" />
                            <div class="sales-funnel-action-options">
                                <div *ngFor="let action of getSalesFunnelActions('Sold')" class="form-check">
                                    <input class="form-check-input" type="checkbox" [id]="'sales-funnel-' + action.key"
                                        [checked]="isSalesFunnelActionSelected(action.key)"
                                        (change)="toggleSalesFunnelAction(action.key)">
                                    <label class="form-check-label" [for]="'sales-funnel-' + action.key">
                                        {{ action.labelKey | translate }} <small>({{ action.value | number }})</small>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="blocks" style="margin-top: 25px;">
                    <div *ngIf="reportMetrics.BookingPercent" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'LEAD_TO_BOOK_PERCENT' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.BookingPercent | percent:'1.2-2' }}</div>
                        </div>
                    </div>
                    <div *ngIf="reportMetrics.BookToShowPercent" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'BOOK_TO_SHOW_PERCENT' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.BookToShowPercent | percent:'1.2-2' }}</div>
                        </div>
                    </div>
                    <div *ngIf="reportMetrics.LeadToShowPercent" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'LEAD_TO_SHOW_PERCENT' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.LeadToShowPercent | percent:'1.2-2' }}</div>
                        </div>
                    </div>
                </div>
                <div class="blocks" style="margin-top: 25px;">
                    <div *ngIf="reportMetrics.LeadToSoldPercent" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'LEAD_TO_SOLD_PERCENT' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.LeadToSoldPercent | percent:'1.2-2' }}</div>
                        </div>
                    </div>
                    <div *ngIf="reportMetrics.BookToSoldPercent" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'BOOK_TO_SOLD_PERCENT' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.BookToSoldPercent | percent:'1.2-2' }}</div>
                        </div>
                    </div>
                    <div *ngIf="reportMetrics.ShowToSoldPercent" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'SHOW_TO_SOLD_PERCENT' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.ShowToSoldPercent | percent:'1.2-2' }}</div>
                        </div>
                    </div>
                </div>
                <div class="blocks" style="margin-top: 25px;">
                    <div *ngIf="reportMetrics.CostPerBooking" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'COST_PER_BOOKING' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.CostPerBooking | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</div>
                        </div>
                    </div>
                    <div *ngIf="reportMetrics.CostPerShow" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'COST_PER_SHOW' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.CostPerShow | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</div>
                        </div>
                    </div>
                </div>
                <div class="blocks" style="margin-top: 25px;">
                    <div *ngIf="reportMetrics.CostPerAcquisition" class="cac">
                        <div class="metricCardMain">
                            <div class="metricCardLabel">{{ 'COST_PER_ACQUISITION' | translate }}</div>
                            <div class="metricCardValue">{{ reportMetrics.CostPerAcquisition | currency:reportMetrics.Currency:'symbol':currencyPipeFormat }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section *ngIf="iIsRollupReport || (reportMetrics.AllCampaigns && reportMetrics.AllCampaigns.length > 1)">
            <app-report-datatable 
                [iSortColumn]="hasConversionActionBreakdown ? 'Conversions' : 'Leads'"
                [iSortDirection]="'desc'"
                [iColumns]="allCampaignsColumns" 
                [iData$]="reportMetrics.AllCampaigns"
                [iTotalCount]="reportMetrics.AllCampaigns.length"
                [iShowFooter]="reportMetrics.AllCampaigns.length > 25"
                [iStickyHeader]="true"
                [iReportTitle]="'CAMPAIGNS' | translate"
            >
            </app-report-datatable>
        </section>

        <section *ngIf="reportForm.get('showKeywords')?.value && reportMetrics.Keywords && reportMetrics.Keywords.length > 0">
            <app-report-datatable 
                [iSortColumn]="hasConversionActionBreakdown ? 'Conversions' : 'Leads'"
                [iSortDirection]="'desc'"
                [iColumns]="googleKeywordsColumns" 
                [iData$]="reportMetrics.Keywords"
                [iTotalCount]="reportMetrics.Keywords.length"
                [iShowFooter]="reportMetrics.Keywords.length > 25"
                [iStickyHeader]="true"
                [iReportTitle]="'KEYWORDS' | translate"
            >
            </app-report-datatable>
        </section>

        <section *ngIf="reportForm.get('showAds')?.value && reportMetrics.Ads && reportMetrics.Ads.length > 0">
            <app-report-datatable 
                [iSortColumn]="hasConversionActionBreakdown ? 'Conversions' : 'Leads'"
                [iSortDirection]="'desc'"
                [iColumns]="adsColumns" 
                [iData$]="reportMetrics.Ads"
                [iTotalCount]="reportMetrics.Ads.length"
                [iShowFooter]="reportMetrics.Ads.length > 10"
                [iPageSize]="10"
                (oVisibleDataChange)="loadVisibleMetaAdPreviews($event)"
                [iStickyHeader]="true"
                [iReportTitle]="'ADS' | translate"
            >
            </app-report-datatable>
            <!--
            <tr *ngFor="let ad of reportMetrics.Ads">
                <td *ngIf="reportMetrics.Platform === 'Google'">
                    <strong>{{ ad.HeadlinePart1 }}{{ ad.HeadlinePart2 }}{{ ad.HeadlinePart3 }}</strong><br />
                    {{ ad.Desc1 }}{{ ad.Desc2 }}
                </td>
                <td *ngIf="reportMetrics.Platform === 'Meta'">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
                        <div style="min-width: 64px"><img [src]="ad.ThumbnailUrl" alt="Thumbnail" width="64px"></div>
                        <div>
                            <strong>{{ ad.Title }}</strong><br />
                            <span [innerHTML]="formatAdBody(ad.Body)"></span>
                        </div>
                    </div>
                </td>
            </tr>
            -->
        </section>

        <section *ngIf="reportForm.get('showDemographics')?.value && reportMetrics.AgeGenderDemographics && reportMetrics.AgeGenderDemographics.length > 0">
            <app-report-datatable 
                [iSortColumn]="hasConversionActionBreakdown ? 'Conversions' : 'Leads'"
                [iSortDirection]="'desc'"
                [iColumns]="metaDemographicsColumns" 
                [iData$]="reportMetrics.AgeGenderDemographics"
                [iTotalCount]="reportMetrics.AgeGenderDemographics.length"
                [iShowFooter]="reportMetrics.AgeGenderDemographics.length > 25"
                [iStickyHeader]="true"
                [iReportTitle]="'DEMOGRAPHICS' | translate"
            >
            </app-report-datatable>

            <app-report-datatable 
                [iSortColumn]="hasConversionActionBreakdown ? 'Conversions' : 'Leads'"
                [iSortDirection]="'desc'"
                [iColumns]="metaAgeDemographicsColumns" 
                [iData$]="reportMetrics.AgeDemographics"
                [iTotalCount]="reportMetrics.AgeDemographics.length"
                [iShowFooter]="reportMetrics.AgeDemographics.length > 25"
                [iReportTitle]="'AGE_DEMOGRAPHICS' | translate"
            >
            </app-report-datatable>

            <app-report-datatable 
                [iSortColumn]="hasConversionActionBreakdown ? 'Conversions' : 'Leads'"
                [iSortDirection]="'desc'"
                [iColumns]="metaGenderDemographicsColumns" 
                [iData$]="reportMetrics.GenderDemographics"
                [iTotalCount]="reportMetrics.GenderDemographics.length"
                [iShowFooter]="reportMetrics.GenderDemographics.length > 25"
                [iReportTitle]="'GENDER_DEMOGRAPHICS' | translate"
            >
            </app-report-datatable>
        </section>

        <section *ngIf="reportForm.get('showDevices')?.value && reportMetrics.Devices && reportMetrics.Devices.length > 0">
            <app-report-datatable
                [iSortColumn]="hasConversionActionBreakdown ? 'Conversions' : 'Leads'"
                [iSortDirection]="'desc'"
                [iColumns]="devicesColumns"
                [iData$]="reportMetrics.Devices"
                [iTotalCount]="reportMetrics.Devices.length"
                [iShowFooter]="reportMetrics.Devices.length > 25"
                [iReportTitle]="'DEVICES' | translate"
            >
            </app-report-datatable>
        </section>

    </div>
</div>

<div *ngIf="!validPlatform" class="report-view-page records-page datatable-page-shell">
    <div class="datatable-page-surface details-tab-surface report-view-empty">
        <div class="details_top">
            <h3 style="text-align: center;">{{ 'REPORTS_NOT_AVAILABLE' | translate }}</h3>
        </div>
    </div>
</div>
